import React from 'react';
import { Link } from 'react-router-dom';
import { timeEntryJobName, type TimeEntry } from '@/data/scheduleTimeTracking';
import { timeJobPath } from './timeJobPath';
import './clockActions.css';

/**
 * While someone is clocked in, the job and Clock out are one control (Home and Time tracking, 2026-10-28): the green
 * half shows the job number and opens the job, the red half clocks out. The caller supplies the Clock out content.
 */
export default function ClockedInSplitButton({ entry, disabled = false, onClockOut, children }: {
  entry: Pick<TimeEntry, 'job_kind' | 'job_id' | 'job_code' | 'job_name'>;
  disabled?: boolean;
  onClockOut: () => void;
  children: React.ReactNode;
}) {
  return (
    <div className="clocked-in-split" role="group" aria-label={`Clocked in to ${entry.job_code}`}>
      <Link className="clocked-in-split__job" to={timeJobPath(entry.job_kind, entry.job_id)}
        aria-label={`Open ${entry.job_code}`} title={`Open ${entry.job_code} · ${timeEntryJobName(entry)}`}>
        <span className="clocked-in-split__code">{entry.job_code}</span>
        <svg className="clocked-in-split__open" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M14 4h6v6" /><path d="M20 4 11 13" /><path d="M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5" />
        </svg>
      </Link>
      <button type="button" className="btn danger clock-action--out" disabled={disabled} onClick={onClockOut}>{children}</button>
    </div>
  );
}
